class CustomAccordion extends HTMLElement {
    constructor() {
        super();
        this.mutationObserver = new MutationObserver(() => this.initAccordion());
    }

    connectedCallback() {
        this.initAccordion();

        this.mutationObserver.observe(this, {
            childList: true,
            subtree: true,
            attributes: true,
        });
    }

    disconnectedCallback() {
        this.mutationObserver.disconnect();
    }

    initAccordion() {
        this.accordionItems = Array.from(this.querySelectorAll('.accordion-item'));

        this.accordionItems.forEach((item) => {
            const accordionHeader = item.querySelector('.accordion-header');
            if (accordionHeader && !accordionHeader.dataset.listenerAdded) {
                accordionHeader.addEventListener('click', () =>
                    this.toggleAccordion(item)
                );
                accordionHeader.dataset.listenerAdded = true;
            }
        });
    }

    toggleAccordion(item) {
        const accordionContent = item.querySelector('.accordion-content');
        if (accordionContent) {
            const isOpen = item.classList.toggle('open');
            accordionContent.style.maxHeight = isOpen
                ? `${accordionContent.scrollHeight + 15}px`
                : null;
        }
    }
}

customElements.define('custom-accordion', CustomAccordion);
